import { Typography } from '@mui/material';
import {
  confirmBuyerOffer,
  Moxoseparationinlisting,
  postApiCall,
} from 'api/apiService';
import { BUYER_AUTO_OFFER } from 'constant/app.config';
import { useEffect, useState } from 'react';
function DecreasingCounter(props) {
  const [count, setCount] = useState(10);
  const { Offer, groupIt, submitmakeoffer, makeOffer, stage } = props;
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  useEffect(() => {
    if (stage == 'ST2') {
      if (submitmakeoffer) {
        makeOffer();
      } else {
        submitOffer();
      }
      return;
    }
    const timer = setTimeout(() => {
      if (count > 1) {
        setCount(count - 1);
      } else {
        if (submitmakeoffer == true && stage != 'ST2') {
          makeOffer();
        } else {
          submitOffer();
        }
      }
    }, 1000); // Update the count every 1000 milliseconds (1 second)

    return () => {
      clearTimeout(timer);
    }; // Clear the timer when the component unmounts
  }, [count, stage]); // Re-run the effect whenever the count changes

  const submitOffer = () => {
    var txt = Offer;
    var vendorOffer = txt.match(/\d/g);
    vendorOffer = vendorOffer.join('');

    const input = {
      offerUniqueId: props?.offerUniqueId,
      buyerStatus: 'Accepted',
      vendorOfferPrice: vendorOffer,
    };
    confirmBuyerOffer(input).then(async (res) => {
      groupIt();
      if (isNotEmptyArray(res?.dataForBuyerCounterAck))
        Moxoseparationinlisting(
          'dataForBuyerCounterAck',
          res?.dataForBuyerCounterAck
        ); //1
    });
  };
  return (
    <div>
      {stage != 'ST2' && (
        <Typography
          sx={{
            fontFamily: 'poppins!important',
            fontSize: '14px!important',
            fontWeight: 400,
            color: '#6C2AD2',
          }}
        >
          {count} Seconds
        </Typography>
      )}
    </div>
  );
}

export default DecreasingCounter;
